export default __webpack_public_path__ + "static/media/problemset.58d1e29b.svg";